import { IconProps } from './index';

const CalendarLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M14.167 2.5H17.5a.833.833 0 01.834.833v13.334a.833.833 0 01-.834.833h-15a.833.833 0 01-.833-.833V3.333A.833.833 0 012.5 2.5h3.334V.833H7.5V2.5h5V.833h1.667V2.5zM12.5 4.167h-5v1.666H5.834V4.167h-2.5V7.5h13.333V4.167h-2.5v1.666H12.5V4.167zm4.167 5H3.334v6.666h13.333V9.167z"
                fill="currentColor"
            />
        </svg>
    );
};

export default CalendarLine;
